import React from "react";
import { Card, CardTitle, CardBody } from "reactstrap";

function Container(props) {
  const { title, children } = props;
  return (
    <div className="  mt-5 mb-5 container">
      <Card color="dark" outline className="card-black ">
        <CardBody>
          <CardTitle
            tag="h2"
            className="mt-3 justify-content-center d-flex display-4"
          >
            {title}
          </CardTitle>

          {children}
        </CardBody>
      </Card>
    </div>
  );
}

export default Container;



// WEBPACK FOOTER //
// ./src/views/components/Container.jsx